(function () {
  var galleryReady = false;

  function initProductGallery() {
    if (typeof Swiper === 'undefined') return false;

    var root = document.querySelector('section.item[data-section-type="product_page"]');
    if (!root || galleryReady) return true;

    var mainEl = root.querySelector('.mySwiper2');
    var thumbEl = root.querySelector('.mySwiper');
    if (!mainEl) return true;

    var slideCount = mainEl.querySelectorAll('.swiper-slide').length;
    if (!slideCount) return true;

    if (mainEl.swiper && mainEl.swiper.destroy) {
      mainEl.swiper.destroy(true, true);
    }
    if (thumbEl && thumbEl.swiper && thumbEl.swiper.destroy) {
      thumbEl.swiper.destroy(true, true);
    }

    var thumbs = null;
    var thumbCount = thumbEl ? thumbEl.querySelectorAll('.swiper-slide').length : 0;

    if (thumbEl && thumbCount) {
      thumbs = new Swiper(thumbEl, {
        spaceBetween: 10,
        slidesPerView: Math.min(4, thumbCount),
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        freeMode: true,
        breakpoints: {
          768: { slidesPerView: 6 }
        }
      });
    }

    var mainConfig = {
      loop: slideCount > 2,
      spaceBetween: 10,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: mainEl.querySelector('.swiper-button-next'),
        prevEl: mainEl.querySelector('.swiper-button-prev')
      }
    };

    if (thumbs) {
      mainConfig.thumbs = { swiper: thumbs };
    }

    var main = new Swiper(mainEl, mainConfig);

    galleryReady = true;
    root.dataset.galleryReady = 'true';
    return true;
  }

  function getStickyHeader() {
    return (
      document.querySelector('.shopify-section-group-header-group > .shopify-section.section--header') ||
      document.querySelector('.shopify-section.section--header:not(:has(.announcement--root))')
    );
  }

  function updateStickyHeaderOffset() {
    var header = getStickyHeader();
    if (!header) return 0;

    var offset = Math.ceil(header.getBoundingClientRect().height + 12);
    document.documentElement.style.setProperty('--mirailab-sticky-header-offset', offset + 'px');
    return offset;
  }

  function initAnchorScroll() {
    var header = getStickyHeader();
    var offset = updateStickyHeaderOffset();

    if (header && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateStickyHeaderOffset).observe(header);
    }

    window.addEventListener('resize', updateStickyHeaderOffset);

    document.querySelectorAll('.products-content-area .nav a[href^="#"], .product__description .nav a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var hash = link.getAttribute('href');
        if (!hash || hash === '#') return;

        var target = document.getElementById(hash.slice(1));
        if (!target) return;

        e.preventDefault();
        offset = updateStickyHeaderOffset();
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

        if (history.pushState) {
          history.pushState(null, '', hash);
        } else {
          window.location.hash = hash;
        }
      });
    });
  }

  function initQuantitySteppers() {
    if (typeof jQuery === 'undefined') return;

    jQuery('.btn-minus').off('click.mirailabPdp').on('click.mirailabPdp', function (e) {
      var input = jQuery(e.target).closest('.form-type-number').find('input');
      if (input.length && input[0].stepDown) input[0].stepDown();
    });

    jQuery('.btn-plus').off('click.mirailabPdp').on('click.mirailabPdp', function (e) {
      var input = jQuery(e.target).closest('.form-type-number').find('input');
      if (input.length && input[0].stepUp) input[0].stepUp();
    });
  }

  function boot() {
    try {
      if (!initProductGallery()) {
        window.setTimeout(boot, 100);
        return;
      }
    } catch (err) {
      console.error('mirailab-pdp: gallery init failed', err);
      window.setTimeout(boot, 200);
      return;
    }

    initQuantitySteppers();
    initAnchorScroll();
  }

  function start() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    window.addEventListener('load', boot);
  }

  start();
})();
